module.exports = __webpack_public_path__ + "media/images/fr_ca/your_approachto_mindsetting-1326a19cc181a7cba1d7584b86a63308.png";